export function newFeesHistoryVisitor(driver, newestBlock, blockCount = 1, rewardPercentiles) {
    let currentBlockCount = blockCount;
    let currentRewardPercentiles = rewardPercentiles;
    return {
        get newestBlock() { return newestBlock; },
        count(blockCount) {
            if (blockCount !== undefined) {
                currentBlockCount = blockCount;
            }
            return this;
        },
        rewardPercentiles(percentiles) {
            currentRewardPercentiles = percentiles;
            return this;
        },
        get: () => driver.getFeesHistory(newestBlock, currentBlockCount, currentRewardPercentiles)
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmVlcy12aXNpdG9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2ZlZXMtdmlzaXRvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLFVBQVUscUJBQXFCLENBQ2pDLE1BQXFCLEVBQ3JCLFdBQTRCLEVBQzVCLFVBQVUsR0FBRyxDQUFDLEVBQ2QsaUJBQTRCO0lBRTVCLElBQUksaUJBQWlCLEdBQUcsVUFBVSxDQUFDO0lBQ25DLElBQUksd0JBQXdCLEdBQUcsaUJBQWlCLENBQUM7SUFFakQsT0FBTztRQUNILElBQUksV0FBVyxLQUFLLE9BQU8sV0FBVyxDQUFBLENBQUMsQ0FBQztRQUN4QyxLQUFLLENBQUMsVUFBbUI7WUFDckIsSUFBSSxVQUFVLEtBQUssU0FBUyxFQUFFLENBQUM7Z0JBQzNCLGlCQUFpQixHQUFHLFVBQVUsQ0FBQztZQUNuQyxDQUFDO1lBQ0QsT0FBTyxJQUFJLENBQUM7UUFDaEIsQ0FBQztRQUNELGlCQUFpQixDQUFDLFdBQTBCO1lBQ3hDLHdCQUF3QixHQUFHLFdBQVcsQ0FBQztZQUN2QyxPQUFPLElBQUksQ0FBQztRQUNoQixDQUFDO1FBQ0QsR0FBRyxFQUFFLEdBQUcsRUFBRSxDQUFDLE1BQU0sQ0FBQyxjQUFjLENBQUMsV0FBVyxFQUFFLGlCQUFpQixFQUFFLHdCQUF3QixDQUFDO0tBQzdGLENBQUE7QUFDTCxDQUFDIn0=